export const KENNISBANK_URL = "https://leiderschapeninzetbaarheid.nl/";

export const SENTRY_DSN = "https://e531c0e291ad480faefbfe9e626c5982@o178697.ingest.sentry.io/5353098";
export const LIMIT_PER_PAGE = 5;
export const PAGE_SIZE = 9;
